import {
  downloadBookingTickets,
  downloadTicketDocumentByType,
} from '@/features/purchase/purchaseService';
import { TransText } from '@/i18n/trans/text';
import type { PurchaseFlowBookingStorageData } from '@/types/storage';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

const useDownloadTicket = (data: PurchaseFlowBookingStorageData | null) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [isPkPassDownloading, setIsPkPassDownloading] = useState(false);

  const handleTicketDownload = useCallback(async () => {
    if (!data?.bookingId) {
      return;
    }

    try {
      setIsDownloading(true);
      await downloadBookingTickets(data?.bookingId, data?.code);
    } finally {
      setIsDownloading(false);
    }
  }, [data?.bookingId, data?.code]);

  const handlePkPassDownload = useCallback(async () => {
    if (!data?.fulfillments?.length) {
      return;
    }

    try {
      setIsPkPassDownloading(true);
      await Promise.all(
        data?.fulfillments.map(async (fulfillment) => {
          try {
            await downloadTicketDocumentByType(
              fulfillment,
              'PKPASS',
              data?.code
            );
          } catch (error) {
            toast.error(<TransText i18nKey="errorDownloadingPkpass" />);
          }
        })
      );
    } catch (error) {
      toast.error(<TransText i18nKey="errorDownloadingPkpass" />);
    } finally {
      setIsPkPassDownloading(false);
    }
  }, [data?.code, data?.fulfillments]);

  return {
    isDownloading,
    isPkPassDownloading,
    handleTicketDownload,
    handlePkPassDownload,
  };
};

export default useDownloadTicket;
